import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAvatar, FDImage,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import fr from 'facet-rest';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';


const QuestionCard = () => {
  const { onSubmit, resource, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useScrollTopOnMount();

  return (
    <LottieLoadingLayout>
      <FDStack direction={'column'} spacing={4}>
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
            <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} width={300} />
            {resource.withRelationship(fr.relationships.avatar.name,
              (rel) => (
                <FDStack direction={'column'} alignItems={'center'} paddingY={2}>
                  <FDAvatar
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    size={rel.meta('avatarSize')}
                  />
                </FDStack>),
              () => null)}
            {resource.withRelationship(fr.relationships.image.name,
              (rel) => (
                <FDImage
                  src={rel.link('related').url()}
                  alt={rel.meta('altText') || ''}
                  aspectRatio={rel.meta('aspectRatio')}
                  width={240}
                />),
              () => null)}
            <MetaControlField attr={'questionText'} />
            <MetaControlField attr={'description'} />
          </FDStack>
          <MetaControlField
            attr={'choice'}
            onChange={(selection) => {
              logStandardizedEvent(categories.facetQuiz, eventTypes.question, eventSubTypes.select, {
                eventProperties: {
                  ...buildCommonFQEventProperties(resource),
                  choice: selection,
                  sectionId: resource.attr('sectionId'),
                  questionId: resource.attr('questionId'),
                  questionReferenceName: resource.attr('questionReferenceName'),
                },
              });
            }}
            iconLocation={'right'}
            {...dataAttrs('fq multi select input')}
          />
        </FDStack>
        {resource.meta().canPut() && <StepNavigationFooter
          onNext={onSubmit}
          isLoading={saving}
          label={resource.attr('primaryActionLabel') || 'Continue'}
        />}
      </FDStack>
    </LottieLoadingLayout>
  );
};

export { QuestionCard };
